export class CreateUser {
  login_name: string;
  password: string;
  email: string;
  tier: number;
  device_type: number;
  device_id: string;

  constructor(n, p, e, t, dt, did) {
    this.login_name = n;
    this.password = p;
    this.email = e;
    this.tier = t;
    this.device_type = dt;
    this.device_id = did;
  }


}
